import React from 'react'
import { SearchBox } from 'office-ui-fabric-react/lib/SearchBox'

const SearchSourceInput = ({handleSearch}) =>
  <SearchBox
    onSearch={handleSearch}
  />

  export default SearchSourceInput



// WEBPACK FOOTER //
// ./src/SearchSourceInput.js